// extracted by mini-css-extract-plugin
export default {"cls1":"AddPayee-AppPayeeStepper_cls1__957IG","cls2":"AddPayee-AppPayeeStepper_cls2__AEwe0 AddPayee-AppPayeeStepper_cls1__957IG"};